(() => {
  const root = document.getElementById('PinoMarketCountry');
  const form = document.getElementById('PinoMarketCountryForm');
  const select = document.getElementById('PinoMarketCountrySelect');
  if (!root || !form || !select) return;
  const current = root.dataset.country;
  const countries = new Map(Array.from(select.options, option => [option.value, option.textContent.trim()]));
  const preferenceKey = 'pino-market-choice-v2';
  const pendingKey = 'pino-market-transition-v2';
  const status = root.querySelector('.pino-market-country__status');
  const recommendation = root.querySelector('.pino-market-country__recommendation');
  let changing = false;
  const read = key => { try { return JSON.parse(sessionStorage.getItem(key)); } catch (_) { return null; } };
  const write = (key, value) => { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (_) {} };
  const remove = key => { try { sessionStorage.removeItem(key); } catch (_) {} };
  const message = text => { status.textContent = text; status.hidden = !text; };
  const readPreference = () => { try { return JSON.parse(localStorage.getItem(preferenceKey)) || read(preferenceKey); } catch (_) { return read(preferenceKey); } };
  const remember = code => {
    const value = { country: code, at: Date.now() };
    try { localStorage.setItem(preferenceKey, JSON.stringify(value)); } catch (_) { write(preferenceKey, value); }
  };
  const returnPath = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete('country');
    url.searchParams.delete('currency');
    return url.pathname + url.search + url.hash;
  };
  const saveProductState = code => {
    const calculator = document.querySelector('pino-shipping-estimate[data-variant-id]');
    const quantity = calculator && document.getElementById(`Quantity-${calculator.dataset.sectionId}`);
    write(pendingKey, { country: code, at: Date.now(), handle: calculator?.dataset.productHandle, variant: calculator?.dataset.variantId, quantity: quantity?.value });
  };
  function selectCountry(code) {
    code = String(code || '').toUpperCase();
    if (!countries.has(code) || changing) return false;
    recommendation.hidden = true;
    if (code === current) { select.value = current; remember(current); return true; }
    changing = true;
    select.value = code;
    saveProductState(code);
    const returnInput = form.querySelector('[name="return_to"]');
    if (returnInput) returnInput.value = returnPath();
    message(root.dataset.changing);
    document.documentElement.dataset.pinoMarketChanging = 'true';
    document.dispatchEvent(new CustomEvent('pino:market-changing', { detail: { country: code } }));
    try {
      HTMLFormElement.prototype.submit.call(form);
      return true;
    } catch (_) {
      changing = false;
      select.value = current;
      delete document.documentElement.dataset.pinoMarketChanging;
      remove(pendingKey);
      remember(current);
      message(root.dataset.error);
      return false;
    }
  }
  window.PinoMarket = { selectCountry, country: current };
  select.addEventListener('change', () => selectCountry(select.value));
  form.addEventListener('submit', event => { event.preventDefault(); selectCountry(select.value); });
  const confirm = form.querySelector('.pino-market-country__confirm');
  if (confirm) confirm.hidden = true;

  const pending = read(pendingKey);
  if (pending) {
    remove(pendingKey);
    if (Date.now() - pending.at < 120000) {
      if (pending.country !== current) message(root.dataset.error);
      else {
        remember(current);
        const calculator = document.querySelector('pino-shipping-estimate[data-variant-id]');
        const quantity = calculator && document.getElementById(`Quantity-${calculator.dataset.sectionId}`);
        const value = Number(pending.quantity);
        if (quantity && calculator.dataset.productHandle === pending.handle && calculator.dataset.variantId === pending.variant && Number.isInteger(value) && value > 0) {
          quantity.value = String(Math.min(value, Number(quantity.max) || value));
          quantity.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
  }
  window.addEventListener('pageshow', event => { if (event.persisted) window.location.reload(); });
  window.addEventListener('storage', event => {
    if (event.key !== preferenceKey || changing) return;
    const preference = readPreference();
    if (!countries.has(preference?.country) || preference.country === current) return;
    saveProductState(preference.country);
    window.location.reload();
  });
  root.querySelector('[data-market-keep]').addEventListener('click', () => { remember(current); recommendation.hidden = true; });
  root.querySelector('[data-market-accept]').addEventListener('click', () => selectCountry(recommendation.dataset.country));
  const preference = readPreference();
  if (window.Shopify?.designMode || /bot|crawler|spider|slurp/i.test(navigator.userAgent) || preference?.country === current && Date.now() - preference.at < 2592000000) return;
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 4000);
  const route = root.dataset.root.endsWith('/') ? root.dataset.root : root.dataset.root + '/';
  fetch(route + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false', { signal: controller.signal })
    .then(response => response.ok ? response.json() : null)
    .then(data => {
      if (changing) return;
      const country = data?.detected_values?.country?.handle;
      if (!country || !countries.has(country) || country === current) return;
      recommendation.dataset.country = country;
      root.querySelector('[data-market-recommendation-text]').textContent = root.dataset.recommendation.replace('[country]', countries.get(country));
      recommendation.hidden = false;
    })
    .catch(() => {})
    .finally(() => clearTimeout(timeout));
})();
